import { Controller } from 'stimulus';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
class _class extends Controller {
  initialize() {
    this.wrapperSelector = this.wrapperSelectorValue || '.nested-form-wrapper';
  }
  add(e) {
    e.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.targetTarget.insertAdjacentHTML('beforebegin', content);
  }
  remove(e) {
    e.preventDefault();
    const wrapper = e.target.closest(this.wrapperSelector);
    if (wrapper.dataset.newRecord === 'true') {
      wrapper.remove();
    } else {
      wrapper.style.display = 'none';
      wrapper.querySelector("input[name*='_destroy']").value = 1;
    }
  }
}
_defineProperty(_class, "targets", ['target', 'template']);
_defineProperty(_class, "values", {
  wrapperSelector: String
});
export default _class;